export interface FontAwesomeIconProps {
	icon: string;
	mask?: string;
	transform?: string;
	fixedWidth?: boolean;
}

export const EVENTS_ICON = {
	icon: 'star',
	mask: 'calendar',
	transform: 'shrink-10 down-2.5',
};

export const MEMBERS_ICON = {
	icon: 'users',
};

export const SHARES_ICON = {
	icon: 'share',
};

export const DISCUSSIONS_ICON = {
	mask: 'tags',
	icon: 'comment',
	transform: 'shrink-9 left-1',
};

export const ADD_ICON = {
	icon: 'plus',
	transform: 'shrink-4 left-1',
};

export const SORT_BY_DATE_ICON = {
	icon: 'history',
};

export const SORT_BY_ALPH_ASC_ICON = {
	icon: 'sort-alpha-down',
};

export const FILE_CONTENT_ICON = {
	icon: 'paperclip',
	transform: 'flip-v',
};

export const CATEGORIES_ICON = {
	icon: 'tags',
	transform: 'right-1',
};

export const DOWNLOAD_ICON = {
	icon: 'download',
	transform: 'shrink-4',
};

export const DOWNLOAD_ICON_LARGE = {
	icon: 'download',
	transform: 'shrink-1',
};

export const DISCUSSION_VIEW_ICON = {
	icon: 'book-reader',
};

export const GROUP_VIEW_ICON = {
	icon: 'users',
};

export const EVENT_VIEW_ICON = {
	mask: 'calendar',
	icon: 'eye',
	transform: 'shrink-7 down-3',
};

export const EVENT_MEMBERS_ICON = {
	mask: 'calendar',
	icon: 'users',
	transform: 'shrink-7 down-3',
};

export const EVENT_CREATION_ICON = {
	icon: 'calendar-plus',
};

export const SETTINGS_ICON = {
	icon: 'cog',
	transform: 'shrink-4 left-2',
};
